export const EASE = 0.1;
export const MASK_SCALE_EASE = 0.05;
export const MAX_INSET_TOP = 22;
export const MAX_PARALLAX_PERCENT = 15;
